import api from "./api";

export const sendFCMToken = async (token_data) => {
    try{
        const response = await api.post('/notification/save-fcm-token',token_data)
        // console.log(response)
        return response.data;
    }
    catch(error){
        console.error("Error While Saving Notification =>",error)
    }
}

export const get_notifications = async (params = {}) => {

    // console.log("Params => ", params)
  try {
    const response = await api.get(
      "notification/get_notifications",
      { params }
    )
    return response.data
  } catch (error) {
    throw error
  }
}


export const update_notifications = async (id) => {

  try {
    const response = await api.put(
      `notification/update_notification_read/${id}`
    )
    return response.data
  } catch (error) {
    throw error
  }
}



export const get_notifications_count = async () => {

  try {
    const response = await api.get(
      'notification/unread_notification_count'
    )
    return response.data
  } catch (error) {
    throw error
  }
}


export const read_all_notifications = async () => {

  try {
    const response = await api.post(
      'notification/read_all_notification'
    )
    return response.data
  } catch (error) {
    throw error
  }
}



export const get_notifications_bell_icon = async () => {

  try {
    const response = await api.get(
      'notification/get_bell_icon_notifications'
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export const clear_fcm_token = async () => {
    let data = localStorage.getItem('tk_id')
    try{
      let response = await api.post('/notification/clear_fcm',{"token_id":data});
    }
    catch(error){
      console.error('error while clear fcm token',error)
    }    
  }